import React, { useEffect, useState } from 'react';
import Logo from "../../assets/assets/Nibss-Logo.png";
import { Link, useLocation } from "react-router-dom";
import Button3 from "../../components/Button/Button3";
import FormSelect4 from "../../components/FormSelect/FormSelect4";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { handleMicrosoftAccessToken, fetchCentralPayAccountNumber, handleGetBanksNameAndCode, verifyPaymentWithBankTransfer } from '../../redux/Actions/GetDocsActions';
import * as yup from 'yup';
import ThreeDot from "react-loading-indicators/ThreeDot";


const schema = yup.object().shape({
  payerAccountNumber: yup.string()
    .required('Payer Account Number is required')
    .matches(/^\d+$/, 'Payer Account Number must be numeric')
    .min(10, 'Payer Account Number cannot be less 10 characters')
    .max(10, 'Payer Account Number cannot exceed 10 characters'),
  payerBankName: yup.string().required('Payer Bank Name is required')
    .matches(/^[a-zA-Z\s]+$/, 'Payer Bank Name must contain only letters and spaces')
    .min(5, 'Payer Bank Name must be at least 5 characters long'),
  payerName: yup.string().required('Payer Name is required')
    .matches(/^[a-zA-Z\s]+$/, 'Payer Name must contain only letters and spaces')
    .min(5, 'Payer Name must be at least 5 characters long')
    .max(45, 'Payer Name must not exceed 45 characters long')

});

const Loading = () => (
	<ThreeDot variant="bob" color="#ccc" size="small" text="" textColor=""  />
);


const PaymentWithBankTransfer = ({ 
  getAccessToken, 
  fetchCentralPayAccount, 
  isCentralPayAccount, 
  centralPay, 
  handleGetBanksNameAndCode, 
  getBankNameAndCode, 
  verifyBankTransfer, 
  centralPayErrorCode,
  isVerificationStarted,
  isVerificationSuccess
}) => {
  const [userName, setUserName] = useState("")
  const [accessToken, setAccessToken] = useState(null)
  const location = useLocation();
  const { formattedAmount, isGetting, paymentType, productId, transactionId } = location.state || {};
  const [payerAccountNumber, setPayerAccountNumber] = useState('');
  const [payerBankName, setPayerBankName] = useState('');
  const [payerName, setPayerName] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [pwtBtn, setPwtBtn] = useState(false)

  const [timeLeft, setTimeLeft] = useState((process.env.REACT_APP_COUNTER_VALUE || 30)  * 60 );




  const [errors, setErrors] = useState({});

  const handleBlur = async (field) => {
    try {
      await schema.validateAt(field, { [field]: field === 'payerAccountNumber' ? payerAccountNumber : field === 'payerBankName' ? payerBankName : field === "payerName" ? payerName : "" });
      setErrors({});
      validateForm()
    } catch (error) {
      setErrors({ [field]: error.message });
    }
  };
  
  

  const handleInputChange = async (event) => {
    const { name, value } = event.target;
   
  
    // Dynamically update state based on input name
    if (name === 'payerAccountNumber') {
      setPayerAccountNumber(value);
    } else if (name === 'payerBankName') {
      setPayerBankName(value);
    }else if (name === 'payerName'){
      setPayerName(value)
    }
  
    try {
      await schema.validateAt(name, { [name]: value });
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    } catch (error) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: error.message }));
      setIsFormValid(false); // Set form as invalid on error
    }
  };


  const validateForm = async () => {
    try {
      await schema.validate({ payerName, payerAccountNumber, payerBankName });
      setIsFormValid(true);
      setErrors({}); 
    } catch (error) {
      setErrors(
        error.inner.reduce((acc, err) => ({ ...acc, [err.path]: err.message }), {})
      );
      setIsFormValid(false); 
    }
  };

  function addCommas(x) {
    let parts = x.toString().split(".");
    parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join(".");
  }

  // NOSONAR: Consider refactoring this code
  const formatAmt = formattedAmount ? `N${addCommas(formattedAmount)}` : 'Nil'

  // NOSONAR: Consider refactoring this code
  const amountDisplay = isGetting ? '...' : formatAmt;

// Use useEffect to validate the form after state updates
useEffect(() => {
  validateForm(); 
}, [payerName, payerBankName, payerAccountNumber]);


  useEffect(() => {
    const fetchData = async () => {
      await getAccessToken(productId);  
      const user = JSON.parse(localStorage.getItem("user-access-data"));
      const token = localStorage.getItem("kong-access-token");  
      
      setAccessToken(token);
      setUserName(user?.name);  
    
      handleGetBanksNameAndCode();
    };
  
    fetchData();
  }, []);

  useEffect(() => {
    const startTime = Date.now();
    const endTime = startTime + timeLeft * 1000;
    const updateTime = () => {
    const now = Date.now();
    const remainingTime = Math.max(0, Math.floor((endTime - now) / 1000));
    setTimeLeft(remainingTime);
      if (remainingTime === 0) {
        clearInterval(timerId);
        window.location.href = "/dashboard";

      }
    };
    const timerId = setInterval(updateTime, 1000);
    updateTime(); 
    return () => clearInterval(timerId);

  }, [timeLeft]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    if(time === 0){
      window.location.href = "/dashboard";
    }
    return `${String(minutes).padStart(2, "0")}min : ${String(seconds).padStart(2, "0")}sec`;

  };


  const handlePaymentWithBankTransfer = async (event) => {
    event.preventDefault();
    

    try {
      await schema.validate({payerName,  payerAccountNumber, payerBankName });
      // Only proceed if the form is valid
      fetchCentralPayAccount(accessToken, {
        payerName,
        payerAccountNumber,
        amount: formattedAmount,
        payerBankName,
        serviceName: "dfshrdherthttrujruey556t4w3t24t4t23t",
        paymentRequest: "wrfeet",
        paymentType,
        productId,
        transactionId
      });
      // Clear fields after submission

      setPayerAccountNumber("");
      setPayerBankName("");
      setPayerName("");
    } catch (validationError) {
      console.error("Validation failed:", validationError);
      setErrors(validationError.inner.reduce((acc, err) => ({ ...acc, [err.path]: err.message }), {}));
    }
  };


  const verifyTransfer = (e) => {
    setPwtBtn(true)
    try {
      verifyBankTransfer(accessToken, transactionId, centralPay?.accessToken?.transactionId)
    } catch (err) {
      console.error(err)
    }

  }
  return (

    <div className="application">
      <Link to="/">
        {" "}
        <div className="application-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>
      <div className="payment-device">
        <h1>Purchasing Certification with Bank Transfer</h1>
        <div className="payment-start-form pay-with-bank-transfer">
          {!isCentralPayAccount && centralPayErrorCode !== 200 && (   <div>
          <div className="top" >
            <div className="title">Company Name</div>
            <input
              className="type-name"
              type="text"
              placeholder="Enter product description"
              value={userName}
              readOnly
            />
          </div>

          <div className="payment-start-check"   style={{ marginBottom: "-2rem" }}>
            <div className="pay-amount">
              <h4>Payment Amount</h4>
              <h5>
                {amountDisplay}
              </h5>
              <input
                type="hidden"
                name="amount"
              />
            </div>
          </div>
       

          <form

            className="form"
            style={{ marginTop: "1rem" }}
          >
            <div className="top">
            <div>
            <div className="title">Payer Name</div>
            <input
              className="type-name"
              type="text"
              placeholder="Enter your bank account name"
              value={payerName}
              name="payerName"
              onChange={handleInputChange}
              onBlur={() => handleBlur('payerName')}
              id="payerName"
              style={{ marginBottom: "2rem" }}
             
            />
          </div>
              <div className="title"> Applicant Debit Account Number</div>
              <div>

                <input
                  className="type-name"
                  type="text"
                  placeholder="Applicant Debit Account Number"
                  name="payerAccountNumber"
                  value={payerAccountNumber}
                  id="payerAccountNumber"
                  style={{ marginBottom: "2rem" }}
                  onChange={handleInputChange}
                  onBlur={() => handleBlur('payerAccountNumber')}


                />
                {errors.payerAccountNumber && <p className="error" style={{ color: "red", textAlign: "left", position: "relative", top: "-20px" }}>{errors.payerAccountNumber}</p>}
              </div>

              <div className="title"> Applicant Debit Bank Name</div>
              <div>
               
               <FormSelect4 
               getBankNameAndCode={getBankNameAndCode}
               payerBankName={payerBankName}
               handleInputChange={handleInputChange}
               />
            
                {errors.payerBankName && (
                  <p className="error" style={{ color: "red", textAlign: "left" }}>
                    {errors.payerBankName}
                  </p>
                )}

              </div>
              <Button3
                width="100%"
                height="58px"
                word={"MAKE PAYMENT"}
                disabled={!isFormValid}
                onClick={handlePaymentWithBankTransfer}
                isBtnEnabled={!isVerificationStarted  && pwtBtn}
           
              />
            </div>

          </form>
          </div>)}
       
        


          {isCentralPayAccount && centralPayErrorCode === 200 && !pwtBtn && (
            <div style={{
              background: "#fffbf2",
              border: "1px solid #aaa",
              padding: "1em",
              borderRadius: "0.2em",
              lineHeight: 1.5,
              marginBottom: "2em"
         
            }}><pre >{centralPay?.accessToken?.paymentMessage}</pre></div>
          )
         
          }
            {
            isCentralPayAccount && centralPayErrorCode === 200 && (
              <>
                <div style={{display: "flex", gap: "20px", flexDirection: "row"}}>
              <Button3
                width="100%"
                height="58px"
                fontSize="0.8"
                word={"confirm payment once you complete your transfer"}
                disabled={isVerificationStarted}
                onClick={verifyTransfer}
                isBtnEnabled={!isVerificationStarted && pwtBtn}
                
              />

              </div>
              <div  style={{display: "flex", alignItems: "center", justifyContent: "center",  gap: "10px", marginTop: "0.7em"}}><span style={{ color: "#000"}}>Kindly confirm payment before:</span><span style={{ color: "red", fontWeight: "bold", width: "10em"}}>{` ${formatTime(timeLeft)}`}</span></div>
              </>
            )
          }
          
          {(isVerificationStarted || isVerificationSuccess) && pwtBtn && (<div style={{ display: "grid", placeItems: "center"}}><Loading /></div>)} {/* Show loading indicator when isBtnEnabled is false */}
          

          {!isCentralPayAccount && centralPayErrorCode === 500 &&(
            <div style={{
              background: "pink",
              border: "1px solid #red",
              padding: "1em",
              borderRadius: "0.2em",
              lineHeight: 1.5
            }}>Error Getting Account Number</div>
          )  
          }
        </div>

      </div>
    </div>)

}

const mapDispatchToProps = (dispatch) => ({
  getAccessToken: (productId) => dispatch(handleMicrosoftAccessToken(productId)),
  fetchCentralPayAccount: (token, payload) => dispatch(fetchCentralPayAccountNumber(token, payload)),
  handleGetBanksNameAndCode: () => dispatch(handleGetBanksNameAndCode()),
  verifyBankTransfer: (token, payload, cpayTransId) => dispatch(verifyPaymentWithBankTransfer(token, payload, cpayTransId))

});
const mapStateToProps = (state) => {
  return {
    token: state.docs.accessToken,
    isCentralPayAccount: state.docs.isCentralPayAccount,
    centralPayErrorCode: state.docs.centralPayErrorCode,
    centralPay: state.docs.centralPay,
    verifyPWTSuccess: state.docs.verifyPWTSuccess,
    isVerificationSuccess: state.docs.isVerificationSuccess,
    isVerificationStarted: state.docs.isVerificationStarted,
    verifyPWTError: state.docs.verifyPWTError,

    centralPayResponse: state.docs.centralPayResponse,
    isCentralPaymentConfirmed: state.docs.isCentralPaymentConfirmed,
    centralPaymentResponseError: state.docs.centralPaymentResponseError,
    getBankNameAndCode: state.docs.getBankNameAndCode,
    getBankNameAndCodeError: state.docs.getBankNameAndCodeError,
    isBanksAvailable: state.docs.isBanksAvailable,

  };
};
PaymentWithBankTransfer.propTypes = {
  getAccessToken: PropTypes.func,
  accessToken: PropTypes.string,
  fetchCentralPayAccount: PropTypes.func,
  isCentralPayAccount: PropTypes.bool,
  centralPay: PropTypes.shape({
    accessToken: PropTypes.shape({
      paymentMessage: PropTypes.string,
    })


  })

};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentWithBankTransfer);